import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import gsap from 'gsap';
import Emitter from '../core/Emitter';
import Sizes from './utils/Sizes'
import Time from './utils/Time';
import Camera from './Camera';
import Renderer from './Renderer';
import World from './world/World';
import Resources from './utils/Resources';
import sources from './sources';
import Materials from './utils/Materials';
import PostPro from './PostPro';
import { getMouseDegrees, getMousePos } from './utils/bearFollowMouse';
import { headerLogoOnScroll } from '../barba/common';
import * as dat from "dat.gui";
import vertexShader from './shader/vertex.glsl';
import fragmentShader from './shader/fragment.glsl';
import seaVertexShader from './shader/sea/vertex.glsl';
import seaFragmentShader from './shader/sea/fragment.glsl';
import galaxyVertexShader from './shader/galaxy/vertex.glsl';
import galaxyFragmentShader from './shader/galaxy/fragment.glsl';
import Stats from 'stats.js';

let instance = null;

export default class Exp {
    constructor(canvas, pageName) {
        if (instance) {
            return instance
        }
        console.log('New experience');
        instance = this;

        //Options
        this.canvas = canvas;
        this.pageName = pageName;

        //Setup
        this.sizes = new Sizes();
        this.time = new Time();
        this.scene = new THREE.Scene();
        this.resources = new Resources(sources);
        this.camera = new Camera();
        this.renderer = new Renderer();
        this.world = new World();
        this.materials = new Materials();
        this.clock = new THREE.Clock();
        this.previousTime = 0;
        //this.postPro = new PostPro(true);

        switch (this.pageName) {
            case 'home':
                this.setupHome();
                break;
            case 'about':
                this.setupAbout();
                break;
        }
        Emitter.on('resize', () => {
            this.resize();
        })

        Emitter.on('tick', () => {
            this.update();
        })
    }

    setupHome() {
        // Utils
        this.followCursor = {}
        this.followCursor.x = 0;
        this.followCursor.y = 0;
        window.addEventListener('pointermove', (e) => {
            this.followCursor.x = getMousePos(e).x;
            this.followCursor.y = getMousePos(e).y;
        })
        this.allowFollowMouse = false;
        this.objectDistance = 4;

        Emitter.on('resouces_Ready', () => {
            this.initBearMain();
            this.initBearStand();
        })

        this.scrollY = window.scrollY;
        window.addEventListener('scroll', () => {
            this.scrollY = window.scrollY;
        })

        //Disable auto-update shadowMap
        const disableShadowMap = true;
        if (disableShadowMap) {
            this.renderer.instance.shadowMap.autoUpdate = false;
            this.renderer.instance.shadowMap.needsUpdate = true;
        }
    }
    setupAbout() {
        console.log('ABOUTTTT')
        this.showFps();
        this.canvas.style.pointerEvents = 'auto';
        //Orbit controller
        this.orbit();
        
        this.aboutClock = new THREE.Clock()

        //this.makeWave();
        //this.makeGalaxy();
        //this.makeShader();
        this.makingSea();
        //this.makingAnimatedGalaxy();
        //this.makingSpin();
    }
    
    orbit() {
        this.controller = new OrbitControls(this.camera.instance, this.canvas);
        this.controller.enableDamping = true;    
    }

    makingSpin() {
        console.log('making spin');
        document.querySelector('.experience').classList.add('expAbout');
        document.querySelector('.abt-main').style.display = 'block';
        const textureLoader = new THREE.TextureLoader();
        const texture = textureLoader.load('../../img/pre-rf.jpg')
        window.SCROLL.start();
        this.count_prj = 6;
        this.offsetY = .4;
        let color = ['blue','red','green','navy','orange','gray','indigo', 'teal'];
        this.geo_center = new THREE.Group();
        this.geo_center_item = new THREE.Mesh(
            new THREE.SphereBufferGeometry(1,16,16),
            new THREE.MeshBasicMaterial({color: 'darkgray'})
        );
        this.geo_center.position.y = -.4;
        const light = new THREE.DirectionalLight({
            color: 0xffffff,
            intensity: 10000
        });
        light.position.set(0,1,4)
        this.geo_center.add(this.geo_center_item)
        this.geo_center.add(light)
        this.scene.add(this.geo_center)
        let geo_plane = new THREE.PlaneGeometry(1.3,1,256,256);
        
        this.group_plane = new THREE.Group();
        for (let x = 0; x < this.count_prj; x++) {
            let mtl_plane = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                side: THREE.DoubleSide, 
                opacity: 1, 
                transparent: true,
                map: texture,                
            })
            mtl_plane.onBeforeCompile = (shader) => {
                shader.vertexShader = shader.vertexShader.replace(
                    '#include <begin_vertex>',
                    `
                        #include <begin_vertex>
                        transformed.z += (cos(transformed.x * 0.7) - 1.0);
                        transformed.y -= (sin(transformed.x * 0.2));
                    `
                )
            }
            let geo_proj = new THREE.Mesh(
                geo_plane, mtl_plane
            )
            let angle = ((Math.PI * 2) / this.count_prj * x);
            console.log(angle / Math.PI)
            let posX = Math.sin(angle) * 1.8;
            let posZ = Math.cos(angle) * 1.8;
            let posY = x * -this.offsetY;
            geo_proj.position.set(posX, posY, posZ);
            geo_proj.rotation.y = angle;
            geo_proj.Url = color[x];
            this.group_plane.add(geo_proj)
        }
        this.scene.add(this.group_plane);
        console.log(this.group_plane)

        //Scroll base
        document.querySelector('.abt-main').style.height = `${100 * (this.count_prj - 1)}vh`;
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.abt-main',
                start: 'top top',
                end: 'bottom bottom',
                //markers: true,
                scrub: true,
            }
        });
        tl.to(this.group_plane.position, {y: this.offsetY * (this.count_prj - 1), ease: 'none'})
        .to(this.group_plane.rotation, {y:(- Math.PI * 2 / this.count_prj) * ( this.count_prj - 1), ease: 'none'}, '0')
        .to(this.geo_center.position, {y: .4, ease: 'none'}, '0')
        .to(this.geo_center.rotation, {y: (- Math.PI / 2), ease: 'none'}, '0');

        //Ray caster
        this.raycaster = new THREE.Raycaster();
        this.pointer = new THREE.Vector2();

        window.addEventListener('pointermove', (e) => {
            this.pointer.x = (e.clientX / window.innerWidth) * 2 - 1;
            this.pointer.y = - (e.clientY / window.innerHeight) * 2 + 1;
        })
        this.currentIntersect = null;

        // Click
        window.addEventListener('click', () => {
            if (this.currentIntersect) {
                let url = this.currentIntersect.object.Url
                let el = document.createElement('a');
                el.setAttribute('href','./')
                console.log(el)
                //el.click();
            }
        })
    }

    showFps() {
        this.stats = new Stats();
        this.stats.showPanel(0);
        document.body.appendChild(this.stats.dom);
    }
    makeWave() {
        //Geo
        this.particleGeo = new THREE.BufferGeometry();
        this.count = 5000;
        const distance = 10;
        const textureLoader = new THREE.TextureLoader();
        const particleTexture = textureLoader.load('../../img/star_06.png')
        const positions = new Float32Array(this.count * 3);
        // for (let i = 0; i < (this.count * 3); i++) {
        //     positions[i] = (Math.random() - 0.5) * 30;
        // }
        for (let i = 0; i < (this.count); i++) {
            let theta = THREE.MathUtils.randFloatSpread(360);
            let phi = THREE.MathUtils.randFloatSpread(360);

            positions[i * 3] = distance * Math.sin(theta) * Math.cos(phi)
            positions[i * 3 + 1] = distance * Math.sin(theta) * Math.sin(phi)
            positions[i * 3 + 2] = distance * Math.cos(theta) * (Math.random() - 0.5) * 2
        }
        this.particleGeo.setAttribute(
            'position',
            new THREE.BufferAttribute(positions, 3)
        )

        //Mtl
        const particleMtl = new THREE.PointsMaterial({
            size: 0.1,
            sizeAttenuation: true
        });
        particleMtl.color = new THREE.Color('orange')
        particleMtl.transparent = true;
        particleMtl.alphaMap = particleTexture;
        particleMtl.depthWrite = false;
        particleMtl.blending = THREE.AdditiveBlending

        //Points
        this.particles = new THREE.Points(this.particleGeo, particleMtl)
        this.scene.add(this.particles);
    }
    makeGalaxy() {
        const gui = new dat.GUI();
        const parameters = {};
        parameters.count = 20000;
        parameters.size = 0.01;
        parameters.radius = 5;
        parameters.branches = 3;
        parameters.spin = 1;
        parameters.randomness = 0.2;
        parameters.randomnessPower = 3;
        parameters.insideColor = '#ff6030';
        parameters.outsideColor = '#1b3984';

        this.geo_galaxy = null;
        let mtl_galaxy = null;
        this.galaxy = null;

        const generateGalaxy = () => {
            if (this.galaxy !== null) {
                this.geo_galaxy.dispose();
                mtl_galaxy.dispose();
                this.scene.remove(this.galaxy);
            }
            console.log("I made a galaxy");

            this.geo_galaxy = new THREE.BufferGeometry();
            const positions = new Float32Array(parameters.count * 3);
            const colors = new Float32Array(parameters.count * 3);
            const insideColor = new THREE.Color(parameters.insideColor);
            const outsideColor = new THREE.Color(parameters.outsideColor);

            for (let i = 0; i < parameters.count; i++) {
                const i3 = i * 3;

                //Positions
                const radius = Math.random() * parameters.radius;
                const spinAngle = radius * parameters.spin;
                const branchAngle = (i % parameters.branches) / parameters.branches * Math.PI * 2;

                const randomX = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : -1) * parameters.randomness * radius;
                const randomY = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : -1) * parameters.randomness * radius;
                const randomZ = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : -1) * parameters.randomness * radius;
                positions[i3] = Math.cos(branchAngle + spinAngle) * radius + randomX;
                positions[i3 + 1] = randomY;
                positions[i3 + 2] = Math.sin(branchAngle + spinAngle) * radius + randomZ;

                //Colors
                const mixedColor = insideColor.clone();
                mixedColor.lerp(outsideColor, radius / parameters.radius)
                colors[i3] = mixedColor.r;
                colors[i3 + 1] = mixedColor.g;
                colors[i3 + 2] = mixedColor.b;
            }

            this.geo_galaxy.setAttribute('position', new THREE.BufferAttribute(positions, 3));
            this.geo_galaxy.setAttribute('color', new THREE.BufferAttribute(colors, 3));

            mtl_galaxy = new THREE.PointsMaterial({
                depthWrite: false,
                blending: THREE.AdditiveBlending,
                vertexColors: true
            })

            this.galaxy = new THREE.Points(this.geo_galaxy, mtl_galaxy);
            this.scene.add(this.galaxy)
        }

        gui.add(parameters, 'count').min(1000).max(100000).step(1000).onFinishChange(generateGalaxy);
        gui.add(parameters, 'size').min(0.01).max(1).step(.01).onFinishChange(generateGalaxy);
        gui.add(parameters, 'radius').min(5).max(20).step(1).onFinishChange(generateGalaxy);
        gui.add(parameters, 'branches').min(2).max(20).step(1).onFinishChange(generateGalaxy);
        gui.add(parameters, 'spin').min(-5).max(5).step(0.001).onFinishChange(generateGalaxy);
        gui.add(parameters, 'randomness').min(0).max(2).step(0.01).onFinishChange(generateGalaxy);
        gui.add(parameters, 'randomnessPower').min(1).max(10).step(0.001).onFinishChange(generateGalaxy);
        gui.addColor(parameters, 'insideColor').onFinishChange(generateGalaxy)
        gui.addColor(parameters, 'outsideColor').onFinishChange(generateGalaxy)
        generateGalaxy();
    }
    makeShader() {
        const gui = new dat.GUI();
        const parameters = {};
        const textureLoader = new THREE.TextureLoader();
        const texture = textureLoader.load('../../img/pre-rf.jpg')
        const geo_plane = new THREE.PlaneBufferGeometry(1, 1, 32, 32);
        const count = geo_plane.attributes.position.count;
        const randoms = new Float32Array(count)
        for (let i = 0; i < count; i++) {
            randoms[i] = Math.random()
        }
        geo_plane.setAttribute('aRandom', new THREE.BufferAttribute(randoms, 1))

        this.mtl_plane = new THREE.ShaderMaterial({
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            uniforms: {
                uFrequency: { value: new THREE.Vector2(10, 10) },
                uTime: { value: 0 },
                uTexture: { value: texture }
            },
            transparent: true,
            //wireframe: true
        })

        gui.add(this.mtl_plane.uniforms.uFrequency.value, 'x').min(0).max(20).step(0.01).name('frequencyX');
        gui.add(this.mtl_plane.uniforms.uFrequency.value, 'y').min(0).max(20).step(0.01).name('frequencyY');
        const plane = new THREE.Mesh(geo_plane, this.mtl_plane);
        plane.scale.y = 2 / 3
        this.scene.add(plane)
    }
    makingSea() {
        console.log('Making sea');

        const gui = new dat.GUI();

        //Colors
        const debugObject = {};
        debugObject.depthColor = '#186691';
        debugObject.surfaceColor = '#9bd8ff';

        this.mtl_sea = new THREE.ShaderMaterial({
            vertexShader: seaVertexShader,
            fragmentShader: seaFragmentShader,
            wireframe: true,
            //flatShading: true,
            uniforms: {
                uTime: { value: 0 },

                uBigWavesElevation: { value: 0.2 },
                uBigWavesFrequency: { value: new THREE.Vector2(4, 1.5) },
                uBigWavesSpeed: { value: 0.75 },

                uSmallWavesElevation: { value: 0.15 },
                uSmallWavesFrequency: { value: 3.0 },
                uSmallWavesSpeed: { value: 0.2 },
                uSmallWavesIterations: { value: 4.0 },

                uDepthColor: { value: new THREE.Color(debugObject.depthColor) },
                uSurfaceColor: { value: new THREE.Color(debugObject.surfaceColor) },
                uColorOffset: { value: 0.08 },
                uColorMultiplier: { value: 5.0 },
            }
        });

        gui.add(this.mtl_sea.uniforms.uBigWavesElevation, 'value').min(0).max(1).step(0.001).name('uBigWavesElevation');
        gui.add(this.mtl_sea.uniforms.uBigWavesFrequency.value, 'x').min(0).max(10).step(0.1).name('uBigWavesFrequencyX');
        gui.add(this.mtl_sea.uniforms.uBigWavesFrequency.value, 'y').min(0).max(10).step(0.1).name('uBigWavesFrequencyZ');
        gui.add(this.mtl_sea.uniforms.uBigWavesSpeed, 'value').min(0).max(2).step(0.05).name('uBigWavesSpeed');

        gui.addColor(debugObject, 'depthColor').name('DepthColor').onChange(() => {
            this.mtl_sea.uniforms.uDepthColor.value.set(debugObject.depthColor)
        });
        gui.addColor(debugObject, 'surfaceColor').name('SurfaceColor').onChange(() => {
            this.mtl_sea.uniforms.uSurfaceColor.value.set(debugObject.surfaceColor)
        });
        gui.add(this.mtl_sea.uniforms.uColorOffset, 'value').min(0).max(1).step(0.005).name('uColorOffset');
        gui.add(this.mtl_sea.uniforms.uColorMultiplier, 'value').min(0).max(10).step(0.05).name('uColorMultiplier');

        gui.add(this.mtl_sea.uniforms.uSmallWavesElevation, 'value').min(0).max(1).step(0.001).name('uSmallWavesElevation');
        gui.add(this.mtl_sea.uniforms.uSmallWavesFrequency, 'value').min(0).max(30).step(0.05).name('uSmallWavesFrequency');
        gui.add(this.mtl_sea.uniforms.uSmallWavesSpeed, 'value').min(0).max(1).step(0.001).name('uSmallWavesSpeed');
        gui.add(this.mtl_sea.uniforms.uSmallWavesIterations, 'value').min(1).max(10).step(1).name('uSmallWavesIterations');

        const geo_sea = new THREE.Mesh(
            new THREE.PlaneBufferGeometry(1, 1, 512, 512),
            this.mtl_sea
        )
        geo_sea.rotation.x = - Math.PI / 2;

        this.scene.add(geo_sea)


    }
    makingAnimatedGalaxy() {
        const gui = new dat.GUI();
        const parameters = {};
        parameters.count = 10000;
        parameters.size = 0.01;
        parameters.radius = 5;
        parameters.branches = 3;
        parameters.spin = 0;
        parameters.randomness = 0.2;
        parameters.randomnessPower = 3;
        parameters.insideColor = '#ff6030';
        parameters.outsideColor = '#1b3984';

        this.geo_galaxy = null;
        this.mtl_galaxy = null;
        this.galaxy = null;

        const generateGalaxy = () => {
            if (this.galaxy !== null) {
                this.geo_galaxy.dispose();
                this.mtl_galaxy.dispose();
                this.scene.remove(this.galaxy);
            }
            console.log("I made a galaxy");

            this.geo_galaxy = new THREE.BufferGeometry();
            const positions = new Float32Array(parameters.count * 3);
            const colors = new Float32Array(parameters.count * 3);
            const scales = new Float32Array(parameters.count * 1);
            const randomness = new Float32Array(parameters.count * 3);

            const insideColor = new THREE.Color(parameters.insideColor);
            const outsideColor = new THREE.Color(parameters.outsideColor);

            for (let i = 0; i < parameters.count; i++) {
                const i3 = i * 3;

                //Positions
                const radius = Math.random() * parameters.radius;
                const spinAngle = radius * parameters.spin;
                const branchAngle = (i % parameters.branches) / parameters.branches * Math.PI * 2;

                positions[i3] = Math.cos(branchAngle + spinAngle) * radius;
                positions[i3 + 1] = 0;
                positions[i3 + 2] = Math.sin(branchAngle + spinAngle) * radius;

                //Randomess
                const randomX = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : -1) * parameters.randomness * radius;
                const randomY = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : -1) * parameters.randomness * radius;
                const randomZ = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : -1) * parameters.randomness * radius;

                randomness[i3] = randomX;
                randomness[i3 + 1] = randomY;
                randomness[i3 + 2] = randomZ;

                //Colors
                const mixedColor = insideColor.clone();
                mixedColor.lerp(outsideColor, radius / parameters.radius)
                colors[i3] = mixedColor.r;
                colors[i3 + 1] = mixedColor.g;
                colors[i3 + 2] = mixedColor.b;

                //Scale 
                scales[i] = Math.random();
            }

            this.geo_galaxy.setAttribute('position', new THREE.BufferAttribute(positions, 3));
            this.geo_galaxy.setAttribute('color', new THREE.BufferAttribute(colors, 3));
            this.geo_galaxy.setAttribute('aScale', new THREE.BufferAttribute(scales, 1));
            this.geo_galaxy.setAttribute('aRandomness', new THREE.BufferAttribute(randomness, 3));

            this.mtl_galaxy = new THREE.ShaderMaterial({
                depthWrite: false,
                blending: THREE.AdditiveBlending,
                vertexColors: true,
                vertexShader: galaxyVertexShader,
                fragmentShader: galaxyFragmentShader,
                uniforms: {
                    uTime: { value: 0.0 },
                    uSize: { value: 30 * this.renderer.instance.getPixelRatio() }
                }
            })

            this.galaxy = new THREE.Points(this.geo_galaxy, this.mtl_galaxy);
            this.scene.add(this.galaxy)
        }

        gui.add(parameters, 'count').min(1000).max(100000).step(1000).onFinishChange(generateGalaxy);
        gui.add(parameters, 'size').min(0.01).max(1).step(.01).onFinishChange(generateGalaxy);
        gui.add(parameters, 'radius').min(5).max(20).step(1).onFinishChange(generateGalaxy);
        gui.add(parameters, 'branches').min(2).max(20).step(1).onFinishChange(generateGalaxy);
        gui.add(parameters, 'spin').min(-5).max(5).step(0.001).onFinishChange(generateGalaxy);
        gui.add(parameters, 'randomness').min(0).max(2).step(0.01).onFinishChange(generateGalaxy);
        gui.add(parameters, 'randomnessPower').min(1).max(10).step(0.001).onFinishChange(generateGalaxy);
        gui.addColor(parameters, 'insideColor').onFinishChange(generateGalaxy)
        gui.addColor(parameters, 'outsideColor').onFinishChange(generateGalaxy)
        generateGalaxy();
    }

    resize() {
        this.camera.resize();
        if (this.postPro) {
            this.postPro.resize();
        } else {
            this.renderer.resize();
        }
    }
    update() {
        switch (this.pageName) {
            case 'home':
                this.renderHome()
                console.log(this.renderer.instance.toneMapping)
                break;
            case 'about':
                this.renderAbout()
                break;
        }

        if (this.postPro) {
            this.postPro.update();
        } else {
            this.renderer.update();
        }
    }

    renderHome() {
        const elapsedTime = this.clock.getElapsedTime();
        this.previousTime = elapsedTime;

        // Animate camera 
        this.camera.instanceGroup.position.y = - this.scrollY / this.sizes.height * this.objectDistance;

        if (this.bearmain) {
            this.bearmainGroup.position.y = - this.scrollY / this.sizes.height * this.objectDistance;
            this.bearstandGroup.position.y = - this.scrollY / this.sizes.height * this.objectDistance;
            if (this.allowFollowMouse) {
                this.initBearFollowMouse(this.followCursor);
            } else {
                if (this.bearmain.rotation.y > 0) {
                    this.bearmain.rotation.y += (0 - this.bearmain.rotation.y) * .9;
                }
                if (this.camera.instance.position.x > 0) {
                    this.camera.instance.position.x += (0 - this.camera.instance.position.x) * .9;
                }
            }
            this.array = [this.bearmain.chat, this.bearmain.cup, this.bearmain.mac, this.bearmain.pen, this.bearmain.phone];
            this.array.map((item) => {
                this.anim_hovering(item);
            });
            this.array_2 = [this.bearmain.book, this.bearmain.color, this.bearmain.musicnote_1, this.bearmain.musicnote_2];
            this.array_2.map((item) => {
                this.anim_hovering_2(item);
            });
            this.bearmain.chair.position.y -= Math.sin(1 * 1000 + elapsedTime) / 2400;
            this.bearmain.root.position.y -= Math.sin(1 * 1000 + elapsedTime) / 1400;
            this.bearmain.thighL.position.y -= Math.sin(1 * 1000 + elapsedTime) / 1000;
            this.bearmain.thighR.position.y -= Math.sin(1 * 1000 + elapsedTime) / 1000;
        }
        if (this.mixerHive) {
            this.mixerHive.update(this.clock.getDelta() * this.mixerHive.timeScale);
        }
    }
    renderAbout() {
        this.stats.begin();
        let elaps = this.aboutClock.getElapsedTime();
        //this.renderWave();
        //this.renderGalaxy();
        //this.renderShader();
        this.renderSea();
        //this.renderAnimatedGalaxy();
        //this.renderSpin();
        this.stats.end();
        this.controller.update();
    }
    renderSpin() {
        this.raycaster.setFromCamera(this.pointer, this.camera.instance);

        const intersects = this.raycaster.intersectObjects(this.group_plane.children, false);

        //Hovering
        if (intersects.length) {
            gsap.to(intersects[0].object.scale, {x: 1.2, y: 1.2, z: 1.2, duration: .6});
        }

        for(const object of this.group_plane.children) {
            if (object !== intersects[0]) {
                gsap.to(object.scale, { x: 1, y: 1, z: 1, duration: .6})
            }
        }

        //Mouse enter / leave 
        if (intersects.length) {
            if (!this.currentIntersect) {
                console.log('mouse enter')
            }
            this.currentIntersect = intersects[0]
        } else {
            if (this.currentIntersect) {
                console.log('mouse leave')
            }
            this.currentIntersect = null;
        }
    }
    renderWave() {
        for (let i = 0; i < this.count; i++) {
            const i3 = i * 3;
            const x = this.particleGeo.attributes.position.array[i3];
            const z = this.particleGeo.attributes.position.array[i3 + 2];
            this.particleGeo.attributes.position.array[i3 + 1] = Math.sin(elaps / 4 + x * z)
        }
        this.particleGeo.attributes.position.needsUpdate = true;
    }
    renderGalaxy() {
        this.galaxy.rotation.y = this.galaxy.rotation.y + 0.1 * this.clock.getDelta();
    }
    renderShader() {
        this.mtl_plane.uniforms.uTime.value = this.clock.getElapsedTime();
    }
    renderSea() {
        let elaps = this.aboutClock.getElapsedTime();
        this.mtl_sea.uniforms.uTime.value = elaps;
    }
    renderAnimatedGalaxy() {
        let elaps = this.aboutClock.getElapsedTime();
        this.mtl_galaxy.uniforms.uTime.value = elaps;
    }
    initBearMain() {
        this.envMap = this.resources.items.environmentMapTexture;
        this.scene.environment = this.envMap;
        //this.scene.background = this.envMap;
        this.bearmain = this.resources.items.bearMain.scene;
        this.bearmainGroup = new THREE.Group();
        this.bearmainGroup.add(this.bearmain);
        this.bearmain.traverse((obj) => {
            if (obj.isMesh) {
                if (obj.name == 'bear') {
                    obj.material = this.materials.mtl_dark_skin;
                    obj.castShadow = true;
                    obj.receiveShadow = true;
                    obj.material.envMap = this.envMap;
                    obj.material.envMapIntensity = 0;
                } else {
                    obj.material = this.materials.mtl_dark;
                    obj.receiveShadow = true;
                    obj.material.envMap = this.envMap;
                    obj.material.envMapIntensity = 0;
                }
            }
            switch (obj.name) {
                case "book":
                    this.bearmain.book = obj;
                    break;
                case "chat":
                    this.bearmain.chat = obj;
                    break;
                case "color":
                    this.bearmain.color = obj;
                    break;
                case "cup":
                    this.bearmain.cup = obj;
                    break;
                case "mac":
                    this.bearmain.mac = obj;
                    break;
                case "musicnote_1":
                    this.bearmain.musicnote_1 = obj;
                    break;
                case "musicnote_2":
                    this.bearmain.musicnote_2 = obj;
                    break;
                case "pen":
                    this.bearmain.pen = obj;
                    break;
                case "phone":
                    this.bearmain.phone = obj;
                    break;
                case "chair":
                    this.bearmain.chair = obj;
                    this.bearmain.chair.castShadow = true;
                    this.bearmain.chair.receiveShadow = true;
                    break;
                case "head":
                    this.bearmain.head = obj;
                    break;
                case "neck":
                    this.bearmain.neck = obj;
                    break;
                case "root":
                    this.bearmain.root = obj;
                    break;
                case "thighL":
                    this.bearmain.thighL = obj;
                    break;
                case "thighR":
                    this.bearmain.thighR = obj;
                    break;
                case "footR":
                    this.bearmain.footR = obj;
                    break;
                case "footL":
                    this.bearmain.footL = obj;
                    break;
                default:
                    break;
            }
            this.scene.add(this.bearmainGroup);
        })
        this.world.environment.setLights();
        Emitter.on('loading_done', () => {
            this.animBearMain();
        })
    }

    animBearMain() {
        this.world.environment.animLights();
        this.initAnimStuffs();
        gsap.delayedCall(this.world.environment.tlLight2.duration() / 3 * 2 + 0.4, () => {
            this.initBearInteraction();
        })
        gsap.delayedCall(this.world.environment.tlLight.duration(), () => {
            window.SCROLL.start();
            headerLogoOnScroll();
        })
    }

    initAnimStuffs() {
        this.bearmain.stuffs = this.bearmain.children[1].children;
        this.bearmain.stuffs.forEach((e, i) => {
            let timeDelay = this.world.environment.tlLight.duration() / 3 * 2;
            gsap.from(e.scale, { x: 0, y: 0, z: 0, duration: 1.2, ease: "Power2.easeOut", delay: timeDelay })
            gsap.from(e.position, { x: 0, y: 0, z: 0, duration: 1.2, ease: "Power2.easeOut", delay: timeDelay })
            gsap.from(e.rotation, { y: -2, z: -2, duration: 1.2, ease: "Power2.easeOut", delay: timeDelay })
        })
    }

    initBearFollowMouse(e) {
        let mousecoords = e;
        const moveJointHead = (mouse, joint, degreeLimit) => {
            let degrees = getMouseDegrees(mouse.x, mouse.y, degreeLimit);
            joint.rotation.z = THREE.MathUtils.lerp(
                joint.rotation.z,
                ((0.0405 + THREE.Math.degToRad(degrees.x)) * Math.PI) / 10,
                0.1
            );
            joint.rotation.x =
                0.14 +
                THREE.MathUtils.lerp(
                    joint.rotation.x,
                    ((0.2 - THREE.Math.degToRad(degrees.y)) * Math.PI) / 10,
                    0.1
                );
        };
        const moveJointNeck = (mouse, joint, degreeLimit) => {
            let degrees = getMouseDegrees(mouse.x, mouse.y, degreeLimit);
            joint.rotation.y = THREE.MathUtils.lerp(
                joint.rotation.y,
                (THREE.Math.degToRad(degrees.x) * Math.PI) / 10,
                0.1
            );
            joint.rotation.x =
                0.05 +
                THREE.MathUtils.lerp(
                    joint.rotation.x,
                    ((0.8767 - THREE.Math.degToRad(degrees.y)) * Math.PI) / 10,
                    0.1
                );
        };
        const moveJointBase = (mouse, joint, degreeLimit) => {
            let degrees = getMouseDegrees(mouse.x, mouse.y, degreeLimit);
            joint.rotation.y = THREE.MathUtils.lerp(
                joint.rotation.y,
                (THREE.Math.degToRad(degrees.x) * Math.PI) / 10,
                0.1
            );
            joint.rotation.x = THREE.MathUtils.lerp(
                joint.rotation.x,
                (THREE.Math.degToRad(degrees.y) * Math.PI) / 10,
                0.1
            );
        };
        moveJointHead(mousecoords, this.bearmain.head, -60);
        moveJointNeck(mousecoords, this.bearmain.neck, 15);
        moveJointBase(mousecoords, this.bearmain, 24);
    }

    initBearInteraction() {
        this.allowFollowMouse = true;
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.sc-home-hero',
                start: 'top top',
                end: 'bottom top',
                scrub: 0,
                onLeave: () => {
                    gsap.to('.grad-bg', { autoAlpha: 1, duration: 1, overwrite: true });
                    document.querySelector('.sc-home-about').style.zIndex = '1';
                    gsap.set(this.world.environment.directLight, { intensity: 4 })
                    gsap.set(this.world.environment.directLight2, { intensity: 2 })
                },
                onEnterBack: () => {
                    gsap.to('.grad-bg', { autoAlpha: 0, duration: 1, overwrite: true });
                    document.querySelector('.sc-home-about').style.zIndex = '5';
                    gsap.set(this.world.environment.directLight, { intensity: 8 })
                    gsap.set(this.world.environment.directLight2, { intensity: 6 })
                },

            },
            defaults: {
                ease: 'none'
            },
            onUpdate: () => {
                if (tl.progress() >= 0.33) {
                    this.allowFollowMouse = false;
                } else {
                    this.allowFollowMouse = true;
                }
            }
        })
        tl.to(this.bearmainGroup.rotation, { y: Math.PI, duration: 10 }, '0')
            .to('.sc-home-hero', { yPercent: 16.5, duration: 10 }, '0')
            .to('.sc-home-hero .home-hero-grad', { yPercent: -100, duration: 20 }, '0')
            .to(this.bearmainGroup.position, { z: 10, duration: 30 }, '0')
            .to(this.materials.mtl_dark_skin, { opacity: 0, duration: 1, }, '>-=1')
            .to(this.materials.mtl_dark, { opacity: 0, duration: 1, }, '<0')
            .to('.blur-bg', { opacity: 0, duration: 3 }, '<-=3')
    }

    initBearStand() {
        this.bearstand = this.resources.items.bearStand.scene;
        this.bearstand.position.z = 8;
        this.bearstand.scale.set(2, 2, 2);
        this.bearstandGroup = new THREE.Group();
        this.bearstandGroup.add(this.bearstand);
        this.bearstand.position.y = -.9 * this.objectDistance;
        this.bearstand.rotation.y = - Math.PI / 20;
        this.bearstand.traverse((obj) => {
            if (obj.name == 'bear-standing') {
                obj.material = this.materials.mtl_stand;
                obj.receiveShadow = true;
                obj.material.envMap = this.envMap;
                obj.material.envMapIntensity = 6;
            }
        })
        this.scene.add(this.bearstandGroup)

        this.animBearStand();
    }
    animBearStand() {
        const tlStand = gsap.timeline({
            scrollTrigger: {
                trigger: '.sc-home-proj',
                //start: 'top bottom+=280%',
                start: 'top bottom+=200%',
                end: 'bottom+=20% bottom',
                scrub: 0,
                //markers: true,
                onEnter: () => {
                    this.allowFollowMouse = true;
                    //gsap.set('.experience', { opacity: 1 })
                    //gsap.set('.experience', { 'filter': 'blur(0px)', autoAlpha: 1 })
                },
                onLeaveback: () => {
                    this.allowFollowMouse = false;
                    //gsap.set('.experience', { 'filter': 'blur(8px)', autoAlpha: 0 })
                }
            },
            defaults: {
                ease: 'none'
            }
        })
        tlStand
            .to(this.bearstand.position, { y: -.05 * this.objectDistance, z: -5.6, duration: 15 }, '0')
            .to('.experience', { 'filter': 'blur(0px)', duration: 7 }, '0')
            .to('.experience', { 'filter': 'blur(8px)', duration: 4 }, '7')
            .from(this.bearstand.rotation, { y: Math.PI / 2, duration: 15 }, '0')
    }

    anim_hovering(stuff) {
        stuff.position.y += Math.sin(1 * 1000 + this.clock.elapsedTime) / 1200;
        stuff.rotation.x +=
            (Math.sin(1 * 1000 + this.clock.elapsedTime) * Math.PI) / 2000;
        stuff.rotation.y +=
            (Math.cos(1 * 1000 + this.clock.elapsedTime) * Math.PI) / 3000;
        stuff.rotation.z +=
            (Math.sin(1 * 1000 + this.clock.elapsedTime) * Math.PI) / 4000;
    }
    anim_hovering_2(stuff) {
        stuff.position.y -= Math.sin(1 * 1000 + this.clock.elapsedTime) / 1000;
        stuff.rotation.x +=
            (Math.sin(1 * 1000 + this.clock.elapsedTime) * Math.PI) / 2000;
        stuff.rotation.y +=
            (Math.cos(1 * 1000 + this.clock.elapsedTime) * Math.PI) / 3000;
        stuff.rotation.z +=
            (Math.sin(1 * 1000 + this.clock.elapsedTime) * Math.PI) / 4000;
    }

    initBearStandAndHive() {
        this.bearstand = this.resources.items.bearStand.scene;
        this.bearstand.position.z = 8;
        this.bearstand.scale.set(2, 2, 2);
        this.bearstandGroup = new THREE.Group();
        this.bearstandGroup.add(this.bearstand);
        this.bearstand.position.y = -1 * this.objectDistance;
        this.bearstand.traverse((obj) => {
            if (obj.name == 'bear-standing') {
                obj.material = this.materials.mtl_stand;
                obj.receiveShadow = true;
            }
        })
        this.scene.add(this.bearstandGroup)

        this.beehive = this.resources.items.beeHive.scene;
        this.beehive.position.x = -3.2;
        this.beehive.position.z = 12;
        this.beehive.position.y = -1 * this.objectDistance;
        this.beehive.traverse((obj) => {
            if (obj.isMesh) {
                if (obj.name == 'hive') {
                    obj.material = this.materials.mtl_dark_hive;
                } else {
                    obj.material = this.materials.mtl_dark_bee;
                }
            }
        })

        this.mixerHive = new THREE.AnimationMixer(this.beehive);
        this.mixerHive.timeScale = 14;
        const clip = this.resources.items.beeHive.animations.find((clip) => clip.name === 'hive-animation');
        this.animHive = this.mixerHive.clipAction(clip);
        this.animHive.play();
        this.beehiveGroup = new THREE.Group();
        this.beehiveGroup.add(this.beehive);
        this.scene.add(this.beehiveGroup);

        this.animBearStandAndHive()
    }
    animBearStandAndHive() {
        const tlStand = gsap.timeline({
            scrollTrigger: {
                trigger: '.sc-home-proj',
                start: 'top bottom+=280%',
                end: 'bottom+=20% bottom',
                scrub: 0,
                //markers: true,
                onEnter: () => {
                    this.allowFollowMouse = true;
                    gsap.set('.experience', { autoAlpha: 1 })
                    //gsap.set('.experience', { 'filter': 'blur(0px)', autoAlpha: 1 })
                },
                onLeaveback: () => {
                    this.allowFollowMouse = false;
                    //gsap.set('.experience', { 'filter': 'blur(8px)', autoAlpha: 0 })
                }
            },
            defaults: {
                ease: 'none'
            }
        })
        tlStand
            .to(this.beehive.position, { x: -3.1, z: 0, y: .2 * this.objectDistance, duration: 15 }, '0')
            .to(this.bearstand.position, { y: -.1 * this.objectDistance, z: -5.6, duration: 15 }, '0')
            // .to('.experience', { 'filter': 'blur(0px)', duration: 7 }, '0')
            // .to('.experience', { 'filter': 'blur(8px)', duration: 4 }, '7')
            .from(this.bearstand.rotation, { y: Math.PI / 2, duration: 15 }, '0')
    }
}